<template>
  <div>
    <div id="searcher">
      <div class="wrapper">
        <div class="search-box">
          <div class="search-text">
            <h2>轻研智库 研判未来</h2>
          </div>
          <el-input
            placeholder="请输入检索词"
            v-model="searchInput"
            class="search-input"
            @keyup.enter.native="handleSearch"
            clearable
          >
            <el-button
              class="search-input_button"
              slot="append"
              @click="handleSearch"
              >检索</el-button
            >
          </el-input>
        </div>
      </div>
    </div>
    <div id="body">
      <!-- <div
        :class="showIsHover ? 'top-filter-tabs is-hover' : 'top-filter-tabs'"
      >
        <div class="wrapper">
          <el-tabs
            v-model="filterTab"
            type="card"
            @tab-click="handleFilterTabClick"
          >
            <el-tab-pane label="产业政策" name="0"></el-tab-pane>
            <el-tab-pane label="数据快递" name="1"></el-tab-pane>
            <el-tab-pane label="国内经济" name="2"></el-tab-pane>
            <el-tab-pane label="国际动态" name="3"></el-tab-pane>
          </el-tabs>
        </div>
      </div> -->
      <div class="wrapper">
        <div
          :class="
            searchFilterShow ? 'search-filter filter-show' : 'search-filter'
          "
        >
          <div class="filter-op" @click="searchFilterShow = !searchFilterShow">
            检索筛选 <i class="el-icon-arrow-up"></i>
          </div>
          <el-form label-width="8.0em">
            <el-form-item>
              <div slot="label">
                <img src="~@/assets/images/icon-f-class.png" alt="" />发文机关
              </div>
              <el-button
                class="fitler-more-button"
                type="text"
                @click="filterOrganShowAll = !filterOrganShowAll"
              >
                更多
                <i class="el-icon-arrow-up" v-if="filterOrganShowAll"></i>
                <i class="el-icon-arrow-down" v-else></i>
              </el-button>
              <el-checkbox-group
                v-model="filterIssuingAuthority"
                @change="handleIssuingAuthorityChange"
                :class="filterOrganShowAll ? 'show-all' : ''"
                :style="filterOrganShowAll ? '' : 'max-height: 32px;'"
              >
                <el-checkbox
                  v-for="(item, index) in aggregations.organ"
                  :key="index"
                  :label="item.key"
                >
                  {{ item.key }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item>
              <div slot="label">
                <img src="~@/assets/images/icon-f-type.png" alt="" />政策层级
              </div>
              <el-button
                class="fitler-more-button"
                type="text"
                @click="filterLevelShowAll = !filterLevelShowAll"
              >
                更多
                <i class="el-icon-arrow-up" v-if="filterLevelShowAll"></i>
                <i class="el-icon-arrow-down" v-else></i>
              </el-button>
              <el-checkbox-group
                v-model="filterLevel"
                @change="handleLevelChange"
                :class="filterLevelShowAll ? 'show-all' : ''"
                :style="filterLevelShowAll ? '' : 'max-height: 32px;'"
              >
                <!-- <el-checkbox
                  v-for="(item, index) in aggregations.level"
                  :key="index"
                  :label="item.key"
                >
                  {{ item.key }}
                </el-checkbox> -->
                <el-checkbox
                  label="国家级"
                  v-if="
                    aggregations.level &&
                    aggregations.level.findIndex(
                      (item) => item.key === '国家级'
                    ) > -1
                  "
                >
                  国家级
                </el-checkbox>
                <el-checkbox
                  label="省级"
                  v-if="
                    aggregations.level &&
                    aggregations.level.findIndex(
                      (item) => item.key === '省级'
                    ) > -1
                  "
                >
                  省级
                </el-checkbox>
                <el-checkbox
                  label="地市级"
                  v-if="
                    aggregations.level &&
                    aggregations.level.findIndex(
                      (item) => item.key === '地市级'
                    ) > -1
                  "
                >
                  地市级
                </el-checkbox>
                <el-checkbox
                  label="区县级"
                  v-if="
                    aggregations.level &&
                    aggregations.level.findIndex(
                      (item) => item.key === '区县级'
                    ) > -1
                  "
                >
                  区县级
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item>
              <div slot="label">
                <img src="~@/assets/images/icon-f-target.png" alt="" />发布年份
              </div>
              <el-button
                class="fitler-more-button"
                type="text"
                @click="filterPublishYearShowAll = !filterPublishYearShowAll"
                v-if="
                  aggregations.publish_year &&
                  aggregations.publish_year.length > 9
                "
              >
                更多
                <i class="el-icon-arrow-up" v-if="filterPublishYearShowAll"></i>
                <i class="el-icon-arrow-down" v-else></i>
              </el-button>
              <el-checkbox-group
                v-model="filterPublishYear"
                @change="handlePublishYearChange"
                :class="filterPublishYearShowAll ? 'show-all' : ''"
                :style="filterPublishYearShowAll ? '' : 'max-height: 32px;'"
              >
                <el-checkbox
                  v-for="(item, index) in aggregations.publish_year"
                  :key="index"
                  :label="item.key"
                >
                  {{ item.key }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
        </div>
        <div class="search-top">
          <div class="search-sort">
            <el-form label-width="6em">
              <el-form-item>
                <div slot="label">综合排序</div>
                <el-select
                  v-model="searchSort"
                  size="small"
                  @change="handleSortChange"
                >
                  <el-option :value="0" label="时间"></el-option>
                  <el-option :value="1" label="相关度"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="search-top-page" v-if="showPagination">
            <el-pagination
              :current-page="pageIndex"
              :page-size="pageSize"
              layout="prev,pager,next"
              :total="total"
              @current-change="handleCurrentPageChange"
            >
            </el-pagination>
          </div>
          <div class="search-result">
            找到
            <span>{{ total > 10000 ? "10000+" : total }}</span>
            条结果
            <!-- （用时0.03秒） -->
          </div>
        </div>
        <div
          class="search-op"
          v-if="
            (filterIssuingAuthority && filterIssuingAuthority.length > 0) ||
            (filterLevel && filterLevel.length > 0) ||
            (filterPublishYear && filterPublishYear.length > 0) ||
            (filterTime != null && filterTime != undefined) ||
            (filterPage && filterPage > 0) ||
            filterInput
          "
        >
          <div class="search-filter-item">
            <template
              v-if="filterIssuingAuthority && filterIssuingAuthority.length > 0"
            >
              <span>发文机关：</span>
              <el-tag
                closable
                v-for="(item, index) in filterIssuingAuthority"
                :key="'filterIssuingAuthority' + index"
                @close="handleIssuingAuthorityChange(item, 'remove')"
              >
                <span>{{ item }}</span>
              </el-tag>
            </template>

            <template v-if="filterLevel && filterLevel.length > 0">
              <span>政策层级：</span>
              <el-tag
                closable
                v-for="(item, index) in filterLevel"
                :key="'filterLevel' + index"
                @close="handleLevelChange(item, 'remove')"
              >
                <span>{{ item }}</span>
              </el-tag>
            </template>

            <template v-if="filterPublishYear && filterPublishYear.length > 0">
              <span>发布年份：</span>
              <el-tag
                closable
                v-for="(item, index) in filterPublishYear"
                :key="'filterPublishYear' + index"
                @close="handlePublishYearChange(item, 'remove')"
              >
                <span>{{ item }}</span>
              </el-tag>
            </template>

            <template v-if="filterTime != null && filterTime != undefined">
              <span>发布时间：</span>
              <el-tag
                closable
                v-if="filterTime === 0"
                @close="handleTimeRemove"
              >
                <span>近三天</span>
              </el-tag>
              <el-tag
                closable
                v-else-if="filterTime === 1"
                @close="handleTimeRemove"
              >
                <span>近一周</span>
              </el-tag>
              <el-tag
                closable
                v-else-if="filterTime === 2"
                @close="handleTimeRemove"
              >
                <span>近一个月</span>
              </el-tag>
              <el-tag closable v-else @close="handleTimeRemove">
                <span>
                  {{ dateFormat(filterTimeRange[0], "date") }}
                  -
                  {{ dateFormat(filterTimeRange[1], "date") }}
                </span>
              </el-tag>
            </template>

            <template v-if="filterPage && filterPage > 0">
              <span>报告页数：</span>
              <el-tag closable @close="handlePageChange(0)">
                <span>大于{{ filterPage }}页</span>
              </el-tag>
            </template>

            <template v-if="filterInput">
              <span>发布机构：</span>
              <el-tag
                closable
                @close="
                  filterInput = '';
                  filterInputInstitution = '';
                  changeQueryParams(true);
                "
              >
                <span>{{ filterInput }}</span>
              </el-tag>
            </template>

            <el-button icon="el-icon-delete" size="small" @click="clearFilter"
              >清空筛选</el-button
            >
          </div>
        </div>
        <el-row :gutter="40">
          <el-col :span="18">
            <div class="search-result-list">
              <div class="report-list">
                <el-skeleton :loading="loading" :count="8" animated>
                  <template slot="template">
                    <dl>
                      <dt>
                        <el-skeleton-item variant="h2" style="width: 80%" />
                      </dt>
                      <dd class="time">
                        <el-skeleton-item variant="text" />
                      </dd>
                      <dd class="info">
                        <span class="u">
                          <el-skeleton-item
                            variant="text"
                            style="width: 120px"
                          />
                        </span>
                        <span class="o">
                          <el-skeleton-item
                            variant="text"
                            style="width: 80px"
                          />
                          <el-skeleton-item
                            variant="text"
                            style="width: 80px; margin-left: 25px"
                          />
                        </span>
                      </dd>
                    </dl>
                  </template>
                  <template>
                    <dl v-for="(item, index) in records" :key="index">
                      <dt>
                        <!-- <a :href="item.url" target="_blank" v-html="item.title"></a> -->
                        <el-link
                          :underline="false"
                          :href="'/policy/detail?id=' + item._id"
                          target="_blank"
                          v-html="item.title"
                        ></el-link>

                        <!-- <span v-if="showNewTab(item.publish_time)" class="status s-new"
                  >上新</span
                >
                <span v-if="showDeepTab(item.pdfTab)" class="status s-deep"
                  >深度</span
                > -->
                      </dt>
                      <dd class="time">
                        <span
                          v-html="showPublishTime(item.publish_time)"
                        ></span>
                      </dd>
                      <dd class="info">
                        <!-- <span class="t">
                  <img src="~@/assets/images/icon-time.png" alt="" />
                  {{ dateFormat(item.date, "date") }}
                </span> -->
                        <span class="u">
                          <template v-if="item.organ && item.organ.length > 0">
                            <img src="~@/assets/images/icon-from.png" />
                            <!-- <template v-for="(organ, index) in item.organ">
                      <span :key="index" v-html="organ" v-if="index < 5"></span>
                    </template> -->
                            <el-tooltip placement="top" effect="light">
                              <div
                                slot="content"
                                v-html="item.organ.join(', ')"
                              ></div>
                              <span
                                v-html="
                                  item.organ[0] +
                                  (item.organ.length > 1 ? ' ...' : '')
                                "
                              ></span>
                            </el-tooltip>
                          </template>
                        </span>
                        <span class="o">
                          <!-- <template v-if="item.keywords && item.keywords.length > 0">
                    <img src="~@/assets/images/icon-tag.png" />
                    <template v-for="(keyword, index) in item.keywords">
                      <span
                        :key="index"
                        v-html="keyword"
                        v-if="index < 5"
                      ></span>
                      <span
                        :key="index"
                        v-html="keyword"
                        v-if="keyword.length > 2 && index < 5"
                      ></span>
                    </template>
                  </template> -->
                          <template v-if="item.theme && item.theme.length > 0">
                            <img src="~@/assets/images/icon-tag.png" />
                            <template v-for="(theme, index) in item.theme">
                              <span
                                :key="index"
                                v-html="theme"
                                v-if="index < 2"
                              ></span>
                            </template>
                          </template>
                        </span>
                        <!-- <span class="p">
                  <template v-if="item.pages"> {{ item.pages }}页 </template>
                </span> -->
                      </dd>
                      <!-- <dd class="op">
                <el-button size="small">下载</el-button>
              </dd> -->
                    </dl>

                    <div
                      class="no-data"
                      v-if="!records || records.length === 0"
                    >
                      <div class="tip">
                        <svg
                          t="1626241932884"
                          class="icon"
                          viewBox="0 0 1428 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="2321"
                          width="60"
                          height="60"
                        >
                          <path
                            d="M982.129778 353.975309H572.833185C556.689383 353.975309 543.604938 339.854222 543.604938 322.37037s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 290.765432 1011.358025 304.886519 1011.358025 322.37037S998.286222 353.975309 982.117136 353.975309M982.129778 467.753086H572.833185C556.689383 467.753086 543.604938 453.632 543.604938 436.148148s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 404.54321 1011.358025 418.664296 1011.358025 436.148148S998.286222 467.753086 982.117136 467.753086M805.293827 594.17284H572.681481c-16.080593 0-29.076543-14.121086-29.076543-31.604939s12.995951-31.604938 29.076543-31.604938h232.612346c16.080593 0 29.076543 14.121086 29.076543 31.604938S821.37442 594.17284 805.293827 594.17284"
                            p-id="2322"
                          ></path>
                          <path
                            d="M501.304889 173.675457c-12.995951 0-23.627852 10.49284-23.627852 23.400296v743.626272c0 12.894815 10.631901 23.387654 23.640494 23.387654h602.895802c13.033877 0 23.640494-10.49284 23.640494-23.387654V197.075753c0-12.894815-10.606617-23.387654-23.640494-23.387654h-602.895802zM1104.225975 1024H501.304889C454.934123 1024 417.185185 986.642963 417.185185 940.689383V197.088395C417.185185 151.122173 454.934123 113.777778 501.304889 113.777778h602.921086C1150.622025 113.777778 1188.345679 151.134815 1188.345679 197.088395v743.600988c0 45.95358-37.723654 83.310617-84.119704 83.310617z"
                            p-id="2323"
                          ></path>
                          <path
                            d="M1216.840691 910.222222h-68.54479v-59.897679h68.54479c13.451062 0 24.778272-10.214716 24.778272-22.287802V82.17284c0-12.073086-11.32721-22.287802-24.778272-22.287803H616.245728c-13.451062 0-24.778272 10.214716-24.778271 22.287803v65.068246H530.962963V82.17284C530.962963 36.851358 569.21758 0 616.245728 0h600.594963C1263.86884 0 1302.123457 36.851358 1302.123457 82.185481V828.049383C1302.123457 873.370864 1263.86884 910.222222 1216.840691 910.222222"
                            p-id="2324"
                          ></path>
                          <path
                            d="M1399.049481 910.222222H1192.555457C1176.247309 910.222222 1163.061728 896.088494 1163.061728 878.617284s13.18558-31.604938 29.493729-31.604938h206.494024c16.308148 0 29.493728 14.133728 29.493729 31.604938s-13.18558 31.604938-29.493729 31.604938M514.528395 1024H281.916049c-16.080593 0-29.076543-14.133728-29.076543-31.604938s12.995951-31.604938 29.076543-31.604939h232.612346c16.080593 0 29.076543 14.133728 29.076543 31.604939S530.608988 1024 514.528395 1024M173.372049 1024H28.899556C12.920099 1024 0 1009.866272 0 992.395062S12.920099 960.790123 28.899556 960.790123h144.472493C189.351506 960.790123 202.271605 974.923852 202.271605 992.395062S189.351506 1024 173.372049 1024M326.580148 50.567901h-58.987457C259.451259 50.567901 252.839506 44.904296 252.839506 37.925926s6.611753-12.641975 14.753185-12.641975h58.987457C334.72158 25.283951 341.333333 30.947556 341.333333 37.925926s-6.611753 12.641975-14.753185 12.641975"
                            p-id="2325"
                          ></path>
                          <path
                            d="M290.765432 88.493827c-6.97837 0-12.641975-6.611753-12.641975-14.753185V14.753185C278.123457 6.611753 283.787062 0 290.765432 0s12.641975 6.611753 12.641975 14.753185v58.987457C303.407407 81.882074 297.743802 88.493827 290.765432 88.493827M273.901037 480.395062h-67.407012C197.176889 480.395062 189.62963 471.924938 189.62963 461.432099s7.547259-18.962963 16.864395-18.962963h67.407012c9.317136 0 16.864395 8.470123 16.864395 18.962963s-7.547259 18.962963-16.864395 18.962963"
                            p-id="2326"
                          ></path>
                          <path
                            d="M233.876543 505.679012c-10.49284 0-18.962963-7.547259-18.962963-16.864395v-67.407012c0-9.317136 8.470123-16.864395 18.962963-16.864395s18.962963 7.547259 18.962963 16.864395v67.407012c0 9.317136-8.470123 16.864395-18.962963 16.864395M132.740741 142.222222a28.444444 28.444444 0 1 0 0.025284 56.914173 28.444444 28.444444 0 0 0-0.025284-56.914173m0 85.333334A56.952099 56.952099 0 0 1 75.851852 170.666667C75.851852 139.289284 101.363358 113.777778 132.740741 113.777778s56.888889 25.511506 56.888889 56.888889-25.511506 56.888889-56.888889 56.888889M1384.296296 231.765333a14.791111 14.791111 0 0 0-14.753185 14.753186 14.791111 14.791111 0 0 0 14.753185 14.753185 14.791111 14.791111 0 0 0 14.753185-14.753185 14.791111 14.791111 0 0 0-14.753185-14.753186m0 59.000099c-24.399012 0-44.246914-19.847901-44.246913-44.246913s19.847901-44.246914 44.246913-44.246914 44.246914 19.847901 44.246914 44.246914-19.847901 44.246914-44.246914 44.246913"
                            p-id="2327"
                          ></path>
                        </svg>
                        <div class="text">暂无数据</div>
                      </div>
                    </div>
                    <!-- <dl class="more">
              <dd>下一页</dd>
            </dl> -->
                  </template>
                </el-skeleton>
              </div>
            </div>
            <div class="search-bottom" v-if="showPagination">
              <div class="search-page-total">
                共 {{ total > 10000 ? "10000+" : total }} 条 第
                {{ pageIndex }}/{{ pageCount > 1000 ? "1000+" : pageCount }}页
              </div>
              <div class="search-page">
                <el-pagination
                  :current-page="pageIndex"
                  :page-size="pageSize"
                  layout=" prev,pager,next,jumper"
                  :total="total"
                  @current-change="handleCurrentPageChange"
                >
                </el-pagination>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="adv">
              <div class="right-code">
                <img src="~@/assets/images/code-o.png" alt="" />
              </div>
            </div>
            <div class="hot">
              <div class="inner-title">
                <h4>热门报告</h4>
              </div>
              <div class="inner-content">
                <div class="rank-list">
                  <ul>
                    <li v-for="(item, index) in hotReport" :key="index">
                      <span class="name">
                        <el-tooltip placement="top-start" effect="light">
                          <div slot="content" v-html="item.title"></div>
                          <a
                            class="name"
                            :href="
                              '/report/read?id=' +
                              item.id +
                              '&type=0&title=' +
                              item.title
                            "
                            target="_blank"
                            v-if="
                              item.pdfPath.substring(
                                item.pdfPath.lastIndexOf('.')
                              ) === '.pdf'
                            "
                          >
                            {{ cutstring(item.title, 50) }}
                          </a>
                          <a
                            v-else
                            href="javascript:;"
                            @click="
                              handleDownload(
                                item.id,
                                item.title,
                                item.pdfPath.substring(
                                  item.pdfPath.lastIndexOf('.')
                                )
                              )
                            "
                          >
                            {{ cutstring(item.title, 50) }}
                          </a>
                        </el-tooltip>
                      </span>
                      <span class="info">
                        <span class="time">{{ dateFormat(item.date) }}</span>
                        <span class="from">{{ item.institution }}</span>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { axiosRequest, axiosOptions } from "../../util/request";
import moment from "moment";
import { cutstr } from "../../util/utils";

export default {
  data() {
    return {
      searchFilterShow: false,
      searchInput: "",
      filterLevel: [],
      filterPublishYear: [],
      filterIssuingAuthority: [],
      filterTime: null,
      filterTimeRange: [],
      filterPage: 0,
      filterInputInstitution: "",
      filterInput: "",
      searchSort: 1,
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      pageCount: 0,
      records: [],
      aggregations: {},
      loading: false,
      filterTab: "0",
      showPagination: false,
      showIsHover: false,
      filterOrganShowAll: false,
      filterLevelShowAll: false,
      filterPublishYearShowAll: false,

      hotReport: [],
    };
  },
  created() {
    this.setQueryParams(this.$route.query);

    this.getSearch();

    this.getHotReport();
  },
  watch: {
    "$route.query"(newQuery) {
      this.setQueryParams(newQuery);

      this.getSearch();
    },
  },
  mounted() {},
  methods: {
    cutstring(str, len) {
      return cutstr(str, len);
    },
    getHotReport() {
      axiosRequest(
        "/tool/hot-report",
        {},
        axiosOptions("get", "", "json")
      ).then((res) => {
        if (res.data && res.data.code === 200) {
          this.hotReport = res.data.data.item1;
        }
      });
    },
    handleFilterTabClick(val) {
      this.showIsHover = !this.showIsHover;
      if (this.filterTab !== "0") {
        this.$router.push({
          path: "/news/list",
          query: { filterTab: this.filterTab, keyword: this.searchInput },
        });
      }
    },
    showPublishTime(val) {
      let index = val.lastIndexOf("-");
      let day = val.substring(index + 1);
      let yearMonth = val.substring(0, index);
      return (
        "<span class='day'>" +
        day +
        "</span><br><span class='year-month'>" +
        yearMonth +
        "</span>"
      );
    },
    showNewTab(date) {
      return (new Date() - new Date(date)) / (60 * 60 * 1000) / 24 < 7;
    },
    showDeepTab(tabs) {
      return (
        tabs && tabs.length > 0 && tabs.some((item) => item === "深度研究")
      );
    },
    dateFormat(cellValue, type) {
      if (!cellValue) return "";
      if (type === "date") {
        return moment(cellValue).format("YYYY-MM-DD");
      }

      return moment(cellValue).format("YYYY-MM-DD HH:mm:ss");
    },
    setQueryParams(query) {
      if (query.keyword) {
        this.searchInput = query.keyword;
        this.pageIndex = 1;
        this.pageSize = 10;
        this.filterLevel = [];
        this.filterPublishYear = [];
        this.filterIssuingAuthority = [];
        this.filterTime = null;
        this.filterTimeRange = [];
        this.searchSort = 1;
        this.filterPage = 0;
        this.filterInput = "";
      } else if (query.params) {
        const params = JSON.parse(query.params) || {};
        this.searchInput = params.keywords[0];
        this.pageIndex = params.pageIndex;
        this.pageSize = 10;
        this.filterLevel = params.clusters.level;
        this.filterPublishYear = params.clusters.publish_year;
        this.filterIssuingAuthority = params.clusters.organ;
        this.filterTime = params.filterTime;
        this.filterTimeRange = [params.startTime, params.endTime];
        this.searchSort = params.sort;
        this.filterPage = params.filter.pages;
        this.filterInput = params.filter.institution;
      } else {
        this.searchInput = "";
        this.pageIndex = 1;
        this.pageSize = 10;
        this.filterLevel = [];
        this.filterPublishYear = [];
        this.filterIssuingAuthority = [];
        this.filterTime = null;
        this.filterTimeRange = [];
        this.searchSort = 0;
        this.filterPage = 0;
        this.filterInput = "";
      }
    },
    getQueryParams() {
      // if (!this.searchInput) {
      //   this.searchSort = this.searchInput ? 1 : 0;
      // }

      return {
        keywords: this.searchInput ? [this.searchInput] : [],
        highlight: true,
        aggregations: true,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        clusters: {
          level: this.filterLevel,
          publish_year: this.filterPublishYear,
          organ: this.filterIssuingAuthority,
        },
        filterTime: this.filterTime,
        startTime: this.filterTimeRange
          ? this.dateFormat(this.filterTimeRange[0])
          : null,
        endTime: this.filterTimeRange
          ? this.dateFormat(this.filterTimeRange[1])
          : null,
        sort: this.searchSort,
        filter: {
          pages: this.filterPage,
          institution: this.filterInput,
        },
      };
    },
    changeQueryParams(resetPageIndex) {
      let params = this.getQueryParams();

      if (resetPageIndex) {
        params.pageIndex = 1;
      }

      this.$router.push({
        path: "/policy/list",
        query: { params: JSON.stringify(params) },
      });
    },
    handleSearch() {
      if (!this.searchInput) {
        this.$message.warning("请输入检索词");
        return;
      }

      this.$router.push({
        path: "/policy/list",
        query: { keyword: this.searchInput },
      });
    },
    getSearch(resetPageIndex) {
      this.loading = true;
      this.showPagination = this.searchInput;

      if (resetPageIndex) {
        this.pageIndex = 1;
      }

      let params = this.getQueryParams();

      axiosRequest(
        "/search/policy-match",
        params,
        axiosOptions("post", "application/json", "json")
      )
        .then((res) => {
          this.loading = false;
          if (res.data && res.data.code === 200) {
            this.aggregations = res.data.data.aggregations;

            this.pageCount = res.data.data.results.pages;
            this.total = res.data.data.results.total;
            this.records = res.data.data.results.records;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleLevelChange(val, type) {
      if (type === "remove") {
        let removeIndex = this.filterLevel.findIndex((item) => item === val);
        if (removeIndex > -1) {
          this.filterLevel.splice(removeIndex, 1);
        }
      }
      this.changeQueryParams(true);
    },
    handlePublishYearChange(val, type) {
      if (type === "remove") {
        let removeIndex = this.filterPublishYear.findIndex(
          (item) => item === val
        );
        if (removeIndex > -1) {
          this.filterPublishYear.splice(removeIndex, 1);
        }
      }
      this.changeQueryParams(true);
    },
    handleIssuingAuthorityChange(val, type) {
      if (type === "remove") {
        let removeIndex = this.filterIssuingAuthority.findIndex(
          (item) => item === val
        );
        if (removeIndex > -1) {
          this.filterIssuingAuthority.splice(removeIndex, 1);
        }
      }
      this.changeQueryParams(true);
    },
    handleTimeChange() {
      if (this.filterTime !== 3) {
        this.filterTimeRange = [];
        this.changeQueryParams(true);
      }
    },
    datePickerChange() {
      if (this.filterTimeRange && this.filterTimeRange.length > 0) {
        this.filterTime = 3;
      } else {
        this.filterTimeRange = [];
        this.filterTime = null;
      }
      this.changeQueryParams(true);
    },
    handleTimeRemove() {
      this.filterTime = null;
      this.filterTimeRange = [];
      this.changeQueryParams(true);
    },
    handlePageChange(val) {
      if (!val) {
        this.filterPage = 0;
      }

      this.changeQueryParams(true);
    },
    handleInstitutionSearch() {
      if (!this.filterInputInstitution) {
        this.$message.warning("请输入检索词");
        return;
      }
      this.filterInput = this.filterInputInstitution;

      this.changeQueryParams(true);
    },
    handleSortChange() {
      this.changeQueryParams(true);
    },
    handleCurrentPageChange(currentPage) {
      this.pageIndex = currentPage;
      this.changeQueryParams(false);
    },
    clearFilter() {
      this.filterLevel = [];
      this.filterPublishYear = [];
      this.filterIssuingAuthority = [];
      this.filterTime = null;
      this.filterTimeRange = [];
      this.searchSort = 0;
      this.filterPage = 0;
      this.filterInput = "";
      this.changeQueryParams(true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "@/assets/css/search.scss";
.el-col-18 {
  width: calc(100% - 340px);
}
.el-col-6 {
  width: 340px;
}
::v-deep .top-filter-tabs {
  .el-tabs__item {
    width: calc(100% / 4 - 15px / 4);
  }
}
.search-top-page ::v-deep {
  margin-left: 5px;

  .el-pagination__total:before {
    background-color: #c9e4ed;
  }

  .el-pager li {
    display: inline-block;
  }
  .el-pager li.active {
    margin-left: 5px !important;
  }
}
.search-page ::v-deep {
  .el-pager li {
    display: inline-block;
  }
  .el-pager li.active {
    margin-left: 5px !important;
  }
}

.report-list {
  //   dt {
  //     ::v-deep a {
  //       max-width: 355px;
  //     }
  //   }
  .time {
    background-color: #eaf6f9;
    border: 0;
    ::v-deep {
      .day {
        font-size: 24px;
        color: #3cdd84;
      }
      .year-month {
        font-size: 16px;
        color: #252b3a;
      }
      .el-skeleton__text {
        margin: -10px;
        width: calc(100% + 20px);
        height: calc(100% + 20px);
      }
    }
  }
  ::v-deep dl {
    padding: 18px 18px 18px 140px;

    .year-month {
      font-size: 12px;
    }
  }
}

$searcherHeight: 95px;
$searcherInputHeight: 40px;
#searcher {
  height: $searcherHeight;
  > .wrapper {
    height: 100%;
  }
  .search-box {
    padding: 28px 50px 0 560px;
    text-align: center;
  }
  .search-data {
    display: none;
    margin-bottom: 20px;
    font-size: $fontSizeBig;
    line-height: 40px;
    text-align: center;
    span {
      padding: 0 5px;
      font-size: 1.2em;
      color: #fa3c17;
    }
  }
  .search-input {
    margin: 0 auto;
    &_select {
      width: 140px;
      margin-right: 2px;
      ::v-deep .el-input__inner {
        border-radius: $boxRadius !important;
      }
    }
    &_button {
      width: 150px;
      margin-left: 1px;
      color: #fff;
      font-size: $fontSizeBig;
      height: $searcherInputHeight;
      background-color: $colorMain;
      border-radius: 0 $boxRadius $boxRadius 0;
    }

    ::v-deep {
      .el-input-group__append,
      .el-input-group__prepend {
        border: 0;
        background-color: transparent;
      }
      .el-input-group__append {
        padding-left: 0;
      }
      .el-input-group__prepend {
        padding-right: 0;
      }
      .el-input__inner {
        height: $searcherInputHeight;
        line-height: $searcherInputHeight;
        background-color: #fff;
        border: 0;
        border-radius: $boxRadius 0 0 $boxRadius;
      }
    }
  }
  .search-hot {
    display: none;
    max-width: 700px;
    margin: 15px auto 0;
    color: $colorFontSub;
    line-height: 30px;
    text-align: center;
    @include clip;
    a {
      display: inline-block;
      max-width: 10em;
      vertical-align: top;
      @include clip;
      &:hover {
        color: $colorMain;
      }
      + a {
        margin-left: 10px;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .el-col-18 {
    width: 100%;
  }
  .el-col-6 {
    width: 100%;
  }
  .report-picshow {
    ::v-deep {
      .el-dialog__headerbtn {
        top: -50px;
        right: 0;
      }
    }
    .intro {
      padding-left: 15px;
      .logo {
        position: static;
        float: left;
        margin-right: 10px;
      }
    }
    .picshow {
      ::v-deep {
        .el-carousel__container {
          height: calc(50vw + 64px);
        }
      }
      label {
        height: 44px;
        font-size: 16px;
        line-height: 22px;
        @include clips(2);
      }
      .el-image {
        height: 50vw;
      }
    }
    .report-info {
      .title {
        font-size: 14px;
        line-height: 22px;
      }
      .info {
        display: flex;
        justify-content: space-between;
        > span {
          max-width: 33%;
          @include clip;
          img {
            display: none;
          }
          + span {
            margin-left: 0;
          }
        }
        .o {
          span + span {
            margin-left: 10px;
          }
        }
      }
    }
  }
}
</style>
